import React from "react"
import {serverSideTranslations} from "next-i18next/serverSideTranslations"
import NavBar from "../../components/navigation/NavBar"
import Footer from "../../components/footer/Footer"
import nextI18NextConfig from "../../next-i18next.config.js"
import {useTranslation} from "next-i18next"
import MbpHead from "../../components/head/MbpHead"
import FaqContent from "../../components/faqComponents/FaqContent"
import PropTypes from "prop-types"
import {getFaqSlugCategory} from "../../utility/Helper"
import {getPageData} from "../../pageData"

const faqPage = () => {
	const {t} = useTranslation()
	const title = t("FAQ - MyBikePlan")
	const description = t("")

	return (
		<>
			<MbpHead>
				<title>
					{title}
				</title>
				<meta name="description"
					content={description}/>
				<meta property="og:title"
					content={title}/>
				<meta property="og:description"
					content={description}/>
			</MbpHead>
			<NavBar/>
			<main>
				<FaqContent/>
			</main>
			<Footer/>

		</>
	)
}

export default faqPage

faqPage.propTypes = {
	bikesList: PropTypes.array
}

export async function getStaticPaths({locales}) {
	let paths = []
	locales?.forEach(locale => {
		const tabParams = getFaqSlugCategory(locale)
		const params = tabParams.map(element => `/faq/${element}`)
		paths = paths.concat(params)
	})

	return {
		paths,
		fallback: "blocking"
	}
}

export async function getStaticProps({locale}) {
	return {
		props: {
			...(await getPageData(locale, [])),
			...(await serverSideTranslations(locale, ["common", "URL", "search", "filters"], nextI18NextConfig))
		}
	}
}
